module.exports = __webpack_public_path__ + "img/u393.d9469c62.png";